import Auth0ErrorHandler from './component'
export default Auth0ErrorHandler
